import * as React from "react";
function SvgIcRepeat(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.272 19.813a7.542 7.542 0 117.153-9.885l-2.42.027.009.75 3.296-.038 1.615-2.872-.654-.367-1.18 2.098a8.281 8.281 0 10.392 3.898l-.742-.103a7.568 7.568 0 01-7.47 6.492z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcRepeat;
